const SPECIAL_CHARACTER_SUBSTITUTIONS = {
  '&': 'and',
};

function processSpecialCharacterSubstitutions(translations: Record<string, string>) {
  const result = { ...translations };
  Object.entries(translations).forEach(([key, val]) => {
    Object.entries(SPECIAL_CHARACTER_SUBSTITUTIONS).forEach(([char, sub]) => {
      let matched = false;

      const replacement = key.replace(new RegExp(char, 'gi'), () => {
        matched = true;
        return sub;
      });

      if (matched) {
        result[replacement] = val;
      }
    });
  });
  return result;
}

function processTrimAndCasing(translations: Record<string, string>) {
  const processed = {};
  Object.entries(translations).forEach(([key, val]) => {
    processed[key.trim().toLowerCase()] = val;
  });
  return processed;
}

export function processTranslations(translations: Record<string, string>) {
  return processSpecialCharacterSubstitutions(processTrimAndCasing(translations));
}
